module.exports = __webpack_public_path__ + "img/ddos-ability.cd9ca87.svg";